export const SEASON_ENUM = {
    MARCH : 'march',
    NEWYEAR : 'newYear',
    HALLOWEEN : 'halloween'
}